function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
// src/signals/basic-filter-signal.ts
import { Signal } from "@shared-ui/core-signal-manager/spi";
var SortAndFilterBasicFilterSignal = /*#__PURE__*/function (_Signal) {
  function SortAndFilterBasicFilterSignal() {
    _classCallCheck(this, SortAndFilterBasicFilterSignal);
    return _callSuper(this, SortAndFilterBasicFilterSignal, arguments);
  }
  _inherits(SortAndFilterBasicFilterSignal, _Signal);
  return _createClass(SortAndFilterBasicFilterSignal);
}(Signal);

// src/signals/selected-filter-pill-signal.ts
import { Signal as Signal2 } from "@shared-ui/core-signal-manager/spi";
var SortAndFilterSelectedFilterPillSignal = /*#__PURE__*/function (_Signal2) {
  function SortAndFilterSelectedFilterPillSignal() {
    _classCallCheck(this, SortAndFilterSelectedFilterPillSignal);
    return _callSuper(this, SortAndFilterSelectedFilterPillSignal, arguments);
  }
  _inherits(SortAndFilterSelectedFilterPillSignal, _Signal2);
  return _createClass(SortAndFilterSelectedFilterPillSignal);
}(Signal2);

// src/signals/fragments.ts
import { gql } from "@shared-ui/apollo-client-wrapper";
var SortAndFilterSignalPayloadFragment = gql`
  fragment SortAndFilterBasicFilterPayloadFragment on SortAndFilterBasicFilterPayload {
    filterId
    type
  }

  fragment SortAndFilterSelectedFilterPillPayloadFragment on SortAndFilterSelectedFilterPillPayload {
    deselectionSignalId
    filter {
      ... on EGDSBasicRemovablePill {
        name
        accessibility
        id
        removeAnalytics {
          eventType
          linkName
          referrerId
          uisPrimeMessages {
            schemaName
            messageContent
          }
        }
      }
    }
    filterName {
      ... on EGDSPlainText {
        text
      }
      ... on EGDSBasicLocalizedText {
        template
        models {
          key
          source
        }
      }
    }
  }
`;
export { SortAndFilterBasicFilterSignal, SortAndFilterSelectedFilterPillSignal, SortAndFilterSignalPayloadFragment };